import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAnalyticsContext } from '../../contexts/AnalyticsContext';
import { Home, Calendar, BookOpen, Newspaper, Zap } from 'lucide-react';

interface NavLinksProps {
  subscriptionInfo?: {
    planType: 'free' | 'monthly' | 'yearly' | 'quarterly' | 'per_interview';
  };
}

export function NavLinks({ subscriptionInfo }: NavLinksProps) {
  const { trackEvent } = useAnalyticsContext();
  const navigate = useNavigate();
  const location = useLocation();

  const navigateToDashboard = () => {
    trackEvent('navigation', {
      target_page: 'dashboard',
      source: 'main_navbar'
    });
    navigate('/');
  };

  const navigateToInterviews = () => {
    trackEvent('navigation', {
      target_page: 'my-interviews',
      source: 'main_navbar'
    });
    navigate('/my-interviews');
  };

  const navigateToBrowseSeries = () => {
    trackEvent('navigation', {
      target_page: 'browse-series',
      source: 'main_navbar'
    });
    navigate('/browse-series');
  };

  const navigateToFeed = () => {
    trackEvent('navigation', {
      target_page: 'feed',
      source: 'main_navbar'
    });
    navigate('/feed');
  };

  const navigateToSubscription = () => {
    trackEvent('navigation', {
      target_page: 'subscription',
      source: 'main_navbar',
      cta_type: 'upgrade_plan'
    });
    navigate('/subscription');
  };

  if(location.pathname.includes('setup-profile') || location.pathname.includes('onboarding/subscription') || location.pathname.includes('payment/success') || location.pathname.includes('payment/error')) {
    return null;
  }

  return (
    <div className="flex items-center gap-10">
      {/* My Dashboard - only show when not on / or /dashboard */}
      {location.pathname !== '/' && location.pathname !== '/dashboard' && (
        <button
          onClick={navigateToDashboard}
          className="nav-link font-medium flex items-center gap-2"
        >
          {/* <Home size={18} /> */}
          My Dashboard
        </button>
      )}
      
      <button
        onClick={navigateToInterviews}
        className="nav-link font-medium flex items-center gap-2"
      >
        {/* <Calendar size={18} /> */}
        My Interviews
      </button>

      <button
        onClick={() => window.open('https://learnifie.com?source=mocktrail', '_blank')}
        className="nav-link font-medium flex items-center gap-2"
      >
        {/* <BookOpen size={18} /> */}
        My Learnings
      </button>
      
      {/* <button */}
        {/* onClick={navigateToBrowseSeries} */}
        {/* className="nav-link font-medium flex items-center gap-2" */}
      {/* > */}
        {/* <BookOpen size={18} /> */}
        {/* Browse All Series */}
      {/* </button> */}
      
      <button
        onClick={navigateToFeed}
        className="nav-link font-medium flex items-center gap-2"
      >
        {/* <Newspaper size={18}/> */}
        News For Me
      </button>
      
      
      {/* Upgrade Plan - only show for free users and not on subscription page */}
      {(subscriptionInfo?.planType === 'free' || subscriptionInfo?.planType === 'per_interview') && !location.pathname.includes('subscription') && (
        <button
          onClick={navigateToSubscription}
          className="nav-link font-medium flex items-center gap-2"
        >
          <span className="bg-gradient-to-r from-yellow-500 to-amber-600 dark:from-yellow-400 dark:to-amber-500 bg-clip-text text-transparent">
            Upgrade Plan
          </span>
        </button>
      )}
    </div>
  );
} 